import { render, staticRenderFns } from "./ProductItemShowScreen.vue?vue&type=template&id=caa696ec&"
import script from "./ProductItemShowScreen.vue?vue&type=script&lang=js&"
export * from "./ProductItemShowScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports